import { useEffect, useRef } from 'react'
import Alert from '@mui/material/Alert'
import { useFormatMessage } from '@/translations/useFormatMessage'

interface ItemsRemovedBannerProps {
	count: number
	onDismiss: () => void
}

export function ItemsRemovedBanner({ count, onDismiss }: ItemsRemovedBannerProps) {
	const { t } = useFormatMessage()
	const onDismissRef = useRef(onDismiss)

	useEffect(() => {
		onDismissRef.current = onDismiss
	}, [onDismiss])

	useEffect(() => {
		const id = setTimeout(() => onDismissRef.current(), 10_000)
		return () => clearTimeout(id)
	}, [])

	return (
		<Alert severity="warning" sx={{ borderRadius: 0 }}>
			{t('component:itemsRemovedBanner:message', { count })}
		</Alert>
	)
}
